import moment, { Moment } from "moment";
import MomentUtils from "@date-io/moment";
import i18n from "../i18n";
import { LANGUAGE } from "../Constants";

class LocalizedUtil extends MomentUtils {
  getDatePickerHeaderText(date: Moment) {
    // custom format for calendar picker
    return moment(date).format( i18n.language === 'ja' ? "M月D日 (ddd)": "DD/MM (ddd)");
  }
}

export default LocalizedUtil;

export const getLocaleForCalendar = (): string => {
  return i18n.language || LANGUAGE.JA
}
